import React, { Component } from 'react';
//import Logo from '../../assets/images/kinship-logo.svg';
import EmailLogo from '../../assets/images/email.png';



export default class ResetModal extends Component {
    constructor() {
        super()
    }

    render() {
        if (this.props.isModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="resetModal" >
                    <div class="modal-dialog reset-password-modal" role="document">
                        <div class="modal-content">
                        <div style={{height:'90vh'}}>
                        <div className="container">
                            <div className="forgot-passwordMainDiv" style={{ height: '100%' }}>
                                <div className="EmailLogoDiv">
                                    <img src={EmailLogo} alt="logo" />
                                </div>
                                <div className='reset-password-content-div'>
                                    <h4>Check Your Email</h4>
                                    <p>Please check the email box new password has been sent to your {this.props.txtUserForgetEmail} email address.  </p>
                                </div>
                            <div className='reset-password-login-btn'>
                                    <button type="button" class="btn login-button" id="btnGoToLogin" name="btnGoToLogin" onClick={() => this.props.HandleRouting("login")}>Back to Login</button>
                                    </div>
                                    <div style={{display:'flex'}}>
                                    <div className="forgot-password-link cursor-pointer" onClick={() => this.props.HideResetModal()}>
                                    <p>ForgotPassword?</p>
                                    </div>
                                    <div className="reset-password-link cursor-pointer" onClick={() => this.props.ForgotPassword()}>
                                    <p>ResetPassword?</p>
                                    </div>
                                    </div>
        
                               
                            </div>
        
                        </div>
        
        
                    </div>

                           
                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}